import { useMemo } from 'react'

import { useAvatarEffectSkins } from '@store'

export const useAvatarEffectById = ({ effectId }: { effectId: string }) => {
  const avatarsEffects = useAvatarEffectSkins()

  const effect = useMemo(() => {
    return avatarsEffects.find((effect) => effect.id === effectId)
  }, [effectId])

  return { effect }
}
